// extracted by mini-css-extract-plugin
export default {"container":"SuperAdminDashboard_container__dCl2p"};